import { Section, highlight } from "./shared";

function DataTable({ table, regex }) {
  if (!table?.rows?.length) return null;
  return (
    <div className="mt-3 overflow-x-auto border border-black text-sm">
      {table.title && (
        <div className="px-3 py-1.5 border-b border-black bg-black text-white font-mono text-[10px] uppercase tracking-widest">
          {highlight(table.title, regex)}
        </div>
      )}
      <table className="w-full border-collapse">
        <thead>
          <tr className="border-b border-black">
            {(table.headers || []).map((h, i) => (
              <th key={i} className="text-left px-3 py-1.5 font-heading font-bold bg-white">{highlight(h, regex)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {table.rows.map((row, i) => (
            <tr key={i} className="border-b border-black/10 last:border-b-0">
              {row.map((c, j) => (
                <td key={j} className="px-3 py-1.5 align-top">{highlight(c, regex)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function TablesSection({ tables, regex }) {
  if (!tables?.length) return null;
  return (
    <Section label="Tables">
      <div className="space-y-3">
        {tables.map((t, i) => <DataTable key={i} table={t} regex={regex} />)}
      </div>
    </Section>
  );
}

export { DataTable };
